import { composeIO } from 'react-compose-io'
import TabNotaFiscalView from './TabNotaFiscal.View'
import { tabNotaFiscalIO } from './TabNotaFiscal.IO'

export const TabNotaFiscal = composeIO(TabNotaFiscalView, tabNotaFiscalIO)
